export const withCropOptions = (image) => {
	if(typeof image !== 'string') return '';
	return `${image}?width={width}&height={height}&mode=crop`;
};
